import './StudentsList.scss';

import ErrorInfo from 'components/ErrorInfo/ErrorInfo';
import NewInvitesList from 'components/Organization/NewInvitesList/NewInvitesList';
import Paragraph from 'components/TextComps/Paragraph';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

type Props = {
  validateInvites: () => void;
  errorMsgs: string[];
};

export const StudentsList = observer(({ validateInvites, errorMsgs }: Props) => {
  const { t } = useTranslation();
  const iss = useStores().inviteStudentsStore;

  const deleteStudent = useCallback(
    (email: string) => {
      const index = iss.newInvites.findIndex((invite) => invite.email === email);
      if (index !== -1) {
        iss.newInvites.splice(index, 1);
        validateInvites();
      }
    },
    [iss.newInvites, validateInvites]
  );

  return (
    <div className='students-list'>
      <div className='students-list-header'>
        <Paragraph>
          <>{t('DoubleCheckTheStudentList', { ns: 'studentsPage' })}</>
        </Paragraph>
        {errorMsgs.length > 0
          ? errorMsgs.map((errorMsg, index) => <ErrorInfo key={`error-${index}`} errorMsg={errorMsg} position='static' />)
          : null}
      </div>
      <NewInvitesList deleteStudent={deleteStudent} />
    </div>
  );
});

export default StudentsList;
